module.exports = __webpack_public_path__ + "pe.3d42d42c92ca16f79d4f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pe.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pe.svg
// module chunks = styles